var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAll } from 'lit/decorators.js';
import { translate } from '../../../utilities/translate';
import { SdsDatePickerItem } from '../../shared/sds-datepicker-item/sds-datepicker-item.lit';
import '../../shared/sds-datepicker-item/sds-datepicker-item.lit';
import { getMonthsTemplate, isCurrentSemiAnnual } from '../semi-annual-picker-calculations';
import styles from './semi-annual-page-view.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsSemiAnnualPageView = (() => {
    var _SdsSemiAnnualPageView_hasCurrent_accessor_storage, _SdsSemiAnnualPageView_selectedSemiAnnual_accessor_storage, _SdsSemiAnnualPageView__items_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-semi-annual-page-view')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _hasCurrent_decorators;
    let _hasCurrent_initializers = [];
    let _hasCurrent_extraInitializers = [];
    let _selectedSemiAnnual_decorators;
    let _selectedSemiAnnual_initializers = [];
    let _selectedSemiAnnual_extraInitializers = [];
    let __items_decorators;
    let __items_initializers = [];
    let __items_extraInitializers = [];
    var SdsSemiAnnualPageView = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsSemiAnnualPageView_hasCurrent_accessor_storage.set(this, __runInitializers(this, _hasCurrent_initializers, void 0));
            _SdsSemiAnnualPageView_selectedSemiAnnual_accessor_storage.set(this, (__runInitializers(this, _hasCurrent_extraInitializers), __runInitializers(this, _selectedSemiAnnual_initializers, void 0)));
            _SdsSemiAnnualPageView__items_accessor_storage.set(this, (__runInitializers(this, _selectedSemiAnnual_extraInitializers), __runInitializers(this, __items_initializers, void 0)));
            this.clickHandler = (__runInitializers(this, __items_extraInitializers), (e) => {
                if (e.target instanceof SdsDatePickerItem) {
                    this.selectSemiAnnual(parseInt(e.target.identifier));
                }
                else if (e.target instanceof HTMLDivElement &&
                    e.target.parentElement instanceof SdsDatePickerItem) {
                    this.selectSemiAnnual(parseInt(e.target.parentElement.identifier));
                }
            });
        }
        get hasCurrent() { return __classPrivateFieldGet(this, _SdsSemiAnnualPageView_hasCurrent_accessor_storage, "f"); }
        set hasCurrent(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPageView_hasCurrent_accessor_storage, value, "f"); }
        get selectedSemiAnnual() { return __classPrivateFieldGet(this, _SdsSemiAnnualPageView_selectedSemiAnnual_accessor_storage, "f"); }
        set selectedSemiAnnual(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPageView_selectedSemiAnnual_accessor_storage, value, "f"); }
        get _items() { return __classPrivateFieldGet(this, _SdsSemiAnnualPageView__items_accessor_storage, "f"); }
        set _items(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPageView__items_accessor_storage, value, "f"); }
        render() {
            return html `
            <div @click="${this.clickHandler}" class="sds-semi-annual-picker">
                <sds-datepicker-item
                    class="sds-date-picker-item sds-date-picker-item--full"
                    value="${translate('sds.semi-annual')} 1"
                    identifier="1"
                    ?current="${this.isCurrent(1)}"
                    state="${this.getState(1)}"
                >
                    <div slot="description">${getMonthsTemplate(1)}</div>
                </sds-datepicker-item>
                <sds-datepicker-item
                    class="sds-date-picker-item sds-date-picker-item--full"
                    value="${translate('sds.semi-annual')} 2"
                    identifier="2"
                    ?current="${this.isCurrent(2)}"
                    state="${this.getState(2)}"
                >
                    <div slot="description">${getMonthsTemplate(2)}</div>
                </sds-datepicker-item>
            </div>
        `;
        }
        willUpdate() {
            this.updateStates();
        }
        isCurrent(semiAnnual) {
            return this.hasCurrent && isCurrentSemiAnnual(semiAnnual);
        }
        updateStates() {
            this._items.forEach(item => {
                item.setAttribute('state', this.getState(parseInt(item.identifier)));
            });
        }
        getState(semiAnnual) {
            return semiAnnual === this.selectedSemiAnnual ? 'selected' : 'none';
        }
        selectSemiAnnual(semiAnnual) {
            this.selectedSemiAnnual = semiAnnual;
            this.dispatchEvent(new CustomEvent(SdsSemiAnnualPageView.SEMI_ANNUAL_PAGE_VIEW_CHANGED, {
                detail: {
                    selectedSemiAnnual: this.selectedSemiAnnual,
                },
            }));
        }
    };
    _SdsSemiAnnualPageView_hasCurrent_accessor_storage = new WeakMap();
    _SdsSemiAnnualPageView_selectedSemiAnnual_accessor_storage = new WeakMap();
    _SdsSemiAnnualPageView__items_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSemiAnnualPageView");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _hasCurrent_decorators = [property({ type: Boolean, attribute: 'current' })];
        _selectedSemiAnnual_decorators = [property({ type: Number, attribute: 'selected-semi-annual' })];
        __items_decorators = [queryAll('sds-datepicker-item')];
        __esDecorate(_classThis, null, _hasCurrent_decorators, { kind: "accessor", name: "hasCurrent", static: false, private: false, access: { has: obj => "hasCurrent" in obj, get: obj => obj.hasCurrent, set: (obj, value) => { obj.hasCurrent = value; } }, metadata: _metadata }, _hasCurrent_initializers, _hasCurrent_extraInitializers);
        __esDecorate(_classThis, null, _selectedSemiAnnual_decorators, { kind: "accessor", name: "selectedSemiAnnual", static: false, private: false, access: { has: obj => "selectedSemiAnnual" in obj, get: obj => obj.selectedSemiAnnual, set: (obj, value) => { obj.selectedSemiAnnual = value; } }, metadata: _metadata }, _selectedSemiAnnual_initializers, _selectedSemiAnnual_extraInitializers);
        __esDecorate(_classThis, null, __items_decorators, { kind: "accessor", name: "_items", static: false, private: false, access: { has: obj => "_items" in obj, get: obj => obj._items, set: (obj, value) => { obj._items = value; } }, metadata: _metadata }, __items_initializers, __items_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSemiAnnualPageView = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.SEMI_ANNUAL_PAGE_VIEW_CHANGED = 'sds.semi-annual-page-view.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSemiAnnualPageView = _classThis;
})();
export { SdsSemiAnnualPageView };
